Mosaic.setPlugins([require('./../packages/@scandipwa/webpack-i18n-runtime/src/plugin/App.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/App.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/CheckoutComponent.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/HeaderContainer.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/ProductPageContainer.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/Router.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/StoreStaticReducers.plugin.js'),
require('./../packages/@bodymod/matomo/src/plugin/addToCart.plugin.js'),
require('./../packages/@bodymod/post-nord/src/plugin/CheckoutDeliveryOption.plugin.js'),
require('./../packages/@bodymod/post-nord/src/plugin/CheckoutShipping.plugin.js'),
require('./../packages/@bodymod/post-nord/src/plugin/StoreReducer.plugin.js'),
require('./../packages/@bodymod/packeta/src/plugin/CheckoutDeliveryOption.plugin.js'),
require('./../packages/@bodymod/packeta/src/plugin/CheckoutShipping.plugin.js'),
require('./../packages/@bodymod/packeta/src/plugin/StoreReducer.plugin.js'),
require('./../packages/@bodymod/sale-countdown/src/plugin/ConfigDispatcher.plugin.js'),
require('./../packages/@bodymod/sale-countdown/src/plugin/ConfigQuery.plugin.js'),
require('./../packages/@bodymod/sale-countdown/src/plugin/ConfigReducer.plugin.js'),
require('./../packages/@bodymod/sale-countdown/src/plugin/ProductActions.plugin.js'),
require('./../packages/@bodymod/seo/src/plugin/SeoDataQuery.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CartItemChangeQuantity.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CartPageContainer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CheckoutBillingContainer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CheckoutPurchasePrepare.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CheckoutShippingContainer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/CheckoutSuccessComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ConfigQuery.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/HandleCustomerDataOnInit.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/HomePage.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/MyAccountQuery.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/NoMatch.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductClick.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductList.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductListPageComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductListQuery.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/ProductPageContainer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/Router.container.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/RouterComponentPlugin.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/SearchFieldComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/SearchItemContainer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/SearchOverlayComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/StoreReducer.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/WishlistItemComponent.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/addToCart.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/myAccountLoginRegister.plugin.js'),
require('./../packages/@scandipwa/gtm-new/src/plugin/wishlistItemAddToCart.plugin.js'),
require('./../packages/@scandipwa/gdpr-cookie/src/plugin/ConfigQuery.plugin.js'),
require('./../packages/@scandipwa/gdpr-cookie/src/plugin/GdprCookiePage.plugin.js'),
require('./../packages/@scandipwa/gdpr-cookie/src/plugin/Router.plugin.js'),
require('./../packages/@scandipwa/gdpr-cookie/src/plugin/StoreIndex.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/Checkout.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/CheckoutBilling.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/Html.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/MyAccount.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/MyAccountCreateAccount.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/Notification.plugin.js'),
require('./../packages/@scandipwa/gdpr/src/plugin/Router.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/CategoryDetails.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/CategoryFilterOverlayContainer.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/CategoryPageContainer.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/CategoryReducer.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/CmsBlockContainer.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/ConfigQuery.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/MetaDispatcher.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/NavigationAbstractContainer.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/ProductListInfoDispatcher.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/ProductListQuery.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/ReduceFilters.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/ResetAllButton.plugin.js'),
require('./../packages/@scandipwa/shopbyseo/src/plugin/UrlRewritesQuery.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutBillingContainer.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutComponent.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutContainer.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutPaymentsComponent.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutPaymentsContainer.plugin.js'),
require('./../packages/@scandipwa/adyen-payment/src/plugin/CheckoutQuery.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/Cart.query.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CartOverlay.component.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CartPage.component.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/Checkout.component.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/Checkout.container.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/Checkout.query.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CheckoutBilling.component.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CheckoutBilling.container.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CheckoutPayments.component.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/CheckoutPayments.container.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/ConfigQuery.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/Router.container.plugin.js'),
require('./../packages/@scandipwa/paypal/src/plugin/StoreStaticReducers.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/CategoryPage.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/CategoryPage.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Header.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Header.dispatch.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Header.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Header.state.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Menu.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Menu.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Menu.state.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/MenuItem.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/MenuItem.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/MenuItem.state.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/ProductActions.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Router.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchField.dispatch.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchField.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchItem.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchItem.dispatch.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchOverlay.container.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchOverlay.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/SearchOverlay.state.plugin.js'),
require('./../packages/@scandipwa/upper-navigation-extension/src/plugin/Store.plugin.js'),
require('./../packages/@scandipwa/page-builder/src/plugin/CmsPage.container.plugin.js'),
require('./../packages/@scandipwa/page-builder/src/plugin/Html.component.plugin.js')]);
// eslint-disable-next-line simple-import-sort/sort
import 'react-app-polyfill/ie11';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'Util/Polyfill';
import 'Style/main';

import * as Sentry from '@sentry/react';
import { render } from 'react-dom';

import App from 'Component/App';
import { CURRENT_VERSION } from 'Component/NewVersionPopup/NewVersionPopup.config';
import { isProduction } from 'Util/Sentry';

// let's register service-worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const swUrl = '/service-worker.js';
        navigator.serviceWorker
            .register(swUrl, { scope: '/' });
    });
}
if (isProduction()) {
    Sentry.init({
        dsn: 'https://44e66d3d70aa4baaa386886dd6da2169@o4503925751611392.ingest.sentry.io/4503925753905152',
        release: `javascript-react@${CURRENT_VERSION}`,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
            }),
            new Sentry.Replay({
                maskAllText: false,
                blockAllMedia: false,
                git: ['/graphql']
            })],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.5
    });
}
render(<App />, document.getElementById('root'));
